/**
 * Telephone et e-mail d'un lead : un lien d'appel ou d'envoi, sauf pour un
 * opposant (`nePlusContacter`, regle RGPD non negociable). Son numero et son
 * adresse restent lisibles en texte simple : l'interface ne facilite pas le
 * contact de qui a demande a ne plus l'etre. Seul endroit ou ce choix se fait.
 */
import type { ReactNode } from 'react';
import { lienTelephone } from './format';

export type TypeContact = 'telephone' | 'email';

/** Lien `tel:` ou `mailto:` ; `null` pour un opposant, ou sans valeur utilisable. */
export function lienContact(type: TypeContact, valeur: string | null | undefined, lead: { nePlusContacter: boolean }): string | null {
  if (!valeur || lead.nePlusContacter) return null;
  return type === 'telephone' ? lienTelephone(valeur) : `mailto:${valeur}`;
}

/** Numero ou adresse d'un lead, en lien ou en texte simple selon `lienContact`. */
export function Contact({ type, valeur, lead, className = '', children }: {
  type: TypeContact;
  valeur: string;
  lead: { nePlusContacter: boolean };
  /** Classes communes au lien et au texte ; le lien y ajoute `lien`. */
  className?: string;
  children: ReactNode;
}) {
  const lien = lienContact(type, valeur, lead);
  return lien ? <a href={lien} className={`lien ${className}`}>{children}</a> : <span className={className}>{children}</span>;
}
